import { For } from 'solid-js';
import { removeFromArray, formateDateStr } from '../utils/utils';
import { openPostingDlg } from '../dialogs/postingDlg';
import { openViewPostDlg } from '../dialogs/viewPostDlg';

export function ClientPosts(p: { posts: IPost[]; on_view: () => void }) {
	async function view_action(a: IPost) {
		p.on_view();
		await openViewPostDlg(a);
		if (!a.id) {
			removeFromArray(a, p.posts);
		}
	}

	return (
		<div class="row">
			<label>Posts</label>
			<table class="data_table">
				<thead>
					<tr>
						<th>date</th>
						<th>title</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<For
						each={p.posts}
						fallback={
							<tr>
								<td>No Records Found</td>
							</tr>
						}
					>
						{(a) => (
							<tr>
								<td>{formateDateStr(a.post_date)}</td>
								<td>{a.title}</td>
								<td>
									<a onClick={(e) => view_action(a)}>view</a>
								</td>
							</tr>
						)}
					</For>
				</tbody>
			</table>
		</div>
	);
}
